import { AxiosResponse } from 'axios';
import { ACCOUNT_BILLING_EXCLUSION_HISTORY_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { ODataParams, PagedResponse } from '../types/interfaces';
import { AccountBillingExclusionHistory } from '../types/interfaces/accountBillingExclusionHistory';

export const downloadAccountsHistoryReport = (payload?: {}, query?: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPost(
    ACCOUNT_BILLING_EXCLUSION_HISTORY_API_ENDPOINTS.BILLING_HISTORY +
      ACCOUNT_BILLING_EXCLUSION_HISTORY_API_ENDPOINTS.ACCOUNTS_BILLING_HISTORY_REPORT_DOWNLOAD,
    payload,
    query,
    {
      responseType: 'blob',
    },
  );
};

export const getBillingHistoryOData = (
  params?: ODataParams,
): Promise<AxiosResponse<AccountBillingExclusionHistory[] | PagedResponse<AccountBillingExclusionHistory>>> => {
  return appContextGet(
    ACCOUNT_BILLING_EXCLUSION_HISTORY_API_ENDPOINTS.BILLING_HISTORY + ACCOUNT_BILLING_EXCLUSION_HISTORY_API_ENDPOINTS.ODATA,
    params,
  );
};
